import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import dayjs from 'dayjs'
import Pagination from '../../Pagination'
import SubCategoryList from './SubCategoryList'
import SubCategoryEdit from './SubCategoryEdit'
import SubCategoryAdd from './SubCategoryAdd'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import helpers from '../../../utils/helpers'
import OSearch from 'components/reusable/OSearch'
import CustomSelect from 'components/reusable/CustomSelect'
import { statusOptions } from 'utils/constants'

const Subcategory = ({ manager }) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [categoryAdd, setCategoryAdd] = useState(false)
  const [categoryEdit, setCategoryEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [categoryView, setCategoryView] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [subcategoryList, setSubcategoryList] = useState([])
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setCategoryEdit(!categoryEdit)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleView = item => {
    setCurrentItem(item)
    setCategoryView(!categoryView)
  }

  const handleCategory = () => {
    setCategoryAdd(!categoryAdd)
  }

  const allSubCategory = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      
      let currentPage = page;

      // Safe check to prevent page from going to 0 or negative
      if (
        (data?.deletePage && subcategoryList?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          subcategoryList?.length >= 1)
      ) {
        if (page > 1) {
          currentPage = page - 1;
          setPage(currentPage);
          setPaginationObj({ ...paginationObj, page: currentPage });
        } else {
          currentPage = 1;
        }
      }
      
      const payload = {
        page: currentPage,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }

      const path = apiPath.subcategoryList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setSubcategoryList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all subcategory list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allSubCategory()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      category: '',
      searchKey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }
  const statusPage = e => {
    setPage(1)
    setFilterData({
      ...filterData,
      isReset: false,
      category: e.target.value,
      isFilter: true
    })
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='bg-white border border-[#E9EDF9] rounded-lg'>
          <div className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between'>
            <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
              <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                <div className='relative flex items-center mb-3'>
                  <OSearch
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    placeholder='Category and subcategory name'
                  />
                </div>
                <CustomSelect
                  id='category'
                  name='category'
                  value={filterData.category}
                  onChange={statusPage}
                  options={statusOptions}
                  placeholder='SUBCATEGORY_ALL'
                  t={t}
                />

                <OButton
                  onClick={handleReset}
                  extraClasses='ml-3 mb-3'
                  style={{ borderRadius: '0.5rem' }}
                  label='Reset'
                  type='button'
                />
              </div>
            </div>
            <div className='lg:pt-0 pt-2'>
              <div className='flex'>
                {(manager?.add || user?.role === 'admin') && (
                  <button
                    title='Add subcategory'
                    type='button'
                    className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    onClick={() => handleCategory()}
                  >
                    + {t('SUBCATEGORY_ADD')}
                  </button>
                )}
              </div>
            </div>
          </div>
          <SubCategoryList
            subcategoryList={subcategoryList}
            page={page}
            allSubCategory={allSubCategory}
            handleEdit={handleEdit}
            handleView={handleView}
            currentItem={currentItem}
            categoryView={categoryView}
            setSort={setSort}
            sort={sort}
            setPage={setPage}
            manager={manager}
          />
          {categoryEdit && (
            <SubCategoryEdit
              allSubCategory={allSubCategory}
              handleEdit={handleEdit}
              currentItem={currentItem}
              subcategoryList={subcategoryList}
            />
          )}

          {categoryAdd && (
            <SubCategoryAdd
              categoryAdd={categoryAdd}
              allSubCategory={allSubCategory}
              handleCategory={handleCategory}
              subcategoryList={subcategoryList}
              setPage={setPage}
            />
          )}
          {paginationObj?.totalItems ? (
            <Pagination
              handlePageClick={handlePageClick}
              options={paginationObj}
              page={page}
            />
          ) : null}
        </div>
      </div>
    </>
  )
}

export default Subcategory
